export class CookieBar {
  cookieBar = document.querySelector('.js-cookie-bar');
  cookieBarClose = document.querySelectorAll('.js-close-cookie-bar');
  cookieBarAccept = document.querySelectorAll('.js-accept-cookie-bar');
  cookieName: string = 'acceptCookie';
  cookieValue: boolean = true;

  constructor() {
    if (!document.querySelector('.js-page-with-usercentrincs')) {
      this.init();
    }
  }

  init(): void {
    this.initCloseButtons();
    this.initAcceptButtons();
    if (this.getCookie(this.cookieName) !== this.cookieValue) {
      this.toggleCookieBar();
    }
  }

  initCloseButtons(): void {
    for (let i = 0; i < this.cookieBarClose.length; i++) {
      this.cookieBarClose[i].addEventListener('click', () => {
        this.toggleCookieBar();
      });
    }
  }

  gtag() {
    // @ts-ignore
    dataLayer.push(arguments);
  }

  initAcceptButtons(): void {
    for (let i = 0; i < this.cookieBarAccept.length; i++) {
      this.cookieBarAccept[i].addEventListener('click', () => {
        // @ts-ignore
        this.gtag('consent', 'update', {
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'ad_storage': 'granted',
          'analytics_storage': 'granted',
        });
        this.toggleCookieBar();
      });
    }
  }

  toggleCookieBar(): void {
    this.setCookie(this.cookieName, this.cookieValue.toString(), 31);
    if (this.cookieBar !== null)
      this.cookieBar.classList.toggle('hide');
  }

  setCookie(name: string, value: string, days: number): void {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + date.toUTCString();
    if (this.cookieBar !== null) {
      if (this.cookieBar.getAttribute('data-domain')) {
        let domain = '; domain=' + this.cookieBar.getAttribute('data-domain');
        document.cookie = name + '=' + value + '; ' + expires + '; path=/' + domain;
      } else {
        document.cookie = name + '=' + value + '; ' + expires + '; path=/';
      }
    }
  }

  getCookie(name: string): boolean {
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      if (c.indexOf(name) !== -1) {
        return true;
      }
    }
    return false;
  }
}
